export default "__VITE_ASSET__DAGqURgR__"